import { render, staticRenderFns } from "./PersonalConsiderations.vue?vue&type=template&id=22a4d859&scoped=true"
import script from "./PersonalConsiderations.vue?vue&type=script&lang=ts"
export * from "./PersonalConsiderations.vue?vue&type=script&lang=ts"
import style0 from "./PersonalConsiderations.vue?vue&type=style&index=0&id=22a4d859&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a4d859",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22a4d859')) {
      api.createRecord('22a4d859', component.options)
    } else {
      api.reload('22a4d859', component.options)
    }
    module.hot.accept("./PersonalConsiderations.vue?vue&type=template&id=22a4d859&scoped=true", function () {
      api.rerender('22a4d859', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/companyProjects/ClientTabsComponents/Steps/CarePlanSteps/PersonalConsiderations.vue"
export default component.exports